import styled from '@emotion/styled'

export const LazyFiller = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  min-height: calc(100vh - 60px - 100px);
`

export default LazyFiller
